<template>
	<section class="ImageCarousel">
		<ul class="carousel">
			<li v-for="(card, index) in cards" :key="`card_${index}`">
				<div class="wrapper">
					<img :src="card.image" />
					<A v-if="card.button" @click="onClickButton(card.button)">{{ card.button.label }}</A>
				</div>
			</li>
		</ul>
	</section>
</template>

<script>
	export default {
		props: ['cards'],
		methods: {
			onClickButton(button) {
				this.$emit('select', button);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.ImageCarousel {
		.carousel {
			overflow-x: auto;
			position: relative;
			white-space: nowrap;

			li {
				width: 40rem;
				max-width: 80%;
				display: inline-block;
				position: relative;
				border-radius: 1rem;
				overflow: hidden;
				&:not(:first-child) {
					margin-left: 2rem;
				}

				&::before {
					content: '';
					display: block;
					padding-top: 100%;
				}

				.wrapper {
					display: block;
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						object-position: center;
					}

					A {
						display: block;
						position: absolute;
						bottom: 2rem;
						left: 50%;
						transform: translateX(-50%);
						color: var(--clrTheme);
						background-color: rgba(0, 0, 0, 0.7);
						width: calc(100% - 4rem);
						text-align: center;
						border-radius: 5rem;
						padding: 1rem 0;

						&:hover {
							background-color: var(--clrTheme);
							color: rgba(0, 0, 0, 0.8);
						}
					}
				}
			}
		}
	}
</style>
